/**
 * JAPSeguros Main JavaScript
 * Version: 1.0.0
 */

(function($) {
  'use strict';

  /**
   * Mobile Menu Toggle
   */
  function initMobileMenu() {
    // Use vanilla JS with fallback to jQuery
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');

    if (!menuToggle || !mobileMenu) {
      console.log('Mobile menu elements not found');
      return;
    }

    const menuIcon = menuToggle.querySelector('.menu-icon');
    const closeIcon = menuToggle.querySelector('.close-icon');

    console.log('Mobile menu initialized');

    // Toggle menu function
    function toggleMenu() {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';

      // Toggle aria-expanded
      menuToggle.setAttribute('aria-expanded', !isOpen);

      // Toggle classes
      menuToggle.classList.toggle('active');
      mobileMenu.classList.toggle('is-open');
      document.body.classList.toggle('mobile-menu-open');

      // Toggle icons
      if (menuIcon && closeIcon) {
        if (isOpen) {
          menuIcon.style.display = 'block';
          closeIcon.style.display = 'none';
        } else {
          menuIcon.style.display = 'none';
          closeIcon.style.display = 'block';
        }
      }

      console.log('Menu toggled, isOpen:', !isOpen);
    }

    // Close menu function
    function closeMenu() {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.classList.remove('active');
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('mobile-menu-open');

      if (menuIcon && closeIcon) {
        menuIcon.style.display = 'block';
        closeIcon.style.display = 'none';
      }
    }

    // Button click handler
    menuToggle.addEventListener('click', function(e) {
      e.preventDefault();
      toggleMenu();
    });

    // Close menu when clicking on links
    const menuLinks = mobileMenu.querySelectorAll('a');
    menuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        closeMenu();
      });
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  /**
   * Smooth Scroll for Anchor Links
   */
  function initSmoothScroll() {
    $('a[href*="#"]:not([href="#"])').on('click', function(e) {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
          location.hostname === this.hostname) {

        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 80
          }, 800);
        }
      }
    });
  }

  /**
   * Form Tabs
   */
  function initFormTabs() {
    $('.form-tab-btn').on('click', function() {
      const tab = $(this).data('tab');
      
      // Update button states
      $('.form-tab-btn').removeClass('active');
      $(this).addClass('active');
      
      // Update content states
      $('.form-tab-pane').removeClass('active');
      $('#' + tab).addClass('active');
    });
  }

  /**
   * FAQ Accordion
   */
  function initAccordion() {
    // Old style accordion
    $('.faq-item-header').on('click', function() {
      const item = $(this).parent();
      const content = item.find('.faq-item-content');

      // Close other items
      $('.faq-item').not(item).removeClass('active');
      $('.faq-item-content').not(content).slideUp();

      // Toggle current item
      item.toggleClass('active');
      content.slideToggle();
    });

    // New style accordion with ARIA (for single seguros)
    $('.faq-question').on('click', function() {
      const isExpanded = $(this).attr('aria-expanded') === 'true';
      const answerId = $(this).attr('aria-controls');
      const answer = $('#' + answerId);

      if (!answer.length) {
        return;
      }

      // Close all other FAQ items
      $('.faq-question').not(this).each(function() {
        $(this).attr('aria-expanded', 'false').removeClass('faq-open');
        const otherAnswerId = $(this).attr('aria-controls');
        const otherAnswer = $('#' + otherAnswerId);
        otherAnswer.slideUp(300, function() {
          $(this).attr('hidden', true);
        });
      });

      // Toggle current FAQ item
      $(this).attr('aria-expanded', !isExpanded);
      if (isExpanded) {
        $(this).removeClass('faq-open');
        answer.slideUp(300, function() {
          $(this).attr('hidden', true);
        });
      } else {
        $(this).addClass('faq-open');
        answer.removeAttr('hidden').hide().slideDown(300);
      }
    });

    // Keyboard support for new style accordion
    $('.faq-question').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
      }
    });
  }

  /**
   * Sticky Header on Scroll
   * Only activates when the theme option "Header Fixo ao Fazer Scroll" is on
   * (adds body class "sticky-header" via PHP). Adds .sticky to .site-header
   * when the user has scrolled, triggering the box-shadow style in CSS.
   */
  function initStickyHeader() {
    if (!$('body').hasClass('sticky-header')) return;

    var $header = $('.site-header');
    var scrollThreshold = 50; // px before shadow appears

    $(window).on('scroll.stickyHeader', function() {
      if ($(window).scrollTop() > scrollThreshold) {
        $header.addClass('sticky');
      } else {
        $header.removeClass('sticky');
      }
    });
  }

  /**
   * Lazy Load Images (Fallback for older browsers)
   */
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) {
      // Browser supports native lazy loading
      return;
    }

    // Fallback for older browsers
    const images = document.querySelectorAll('img[loading="lazy"]');

    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove('lazy');
            imageObserver.unobserve(image);
          }
        });
      });

      images.forEach(function(img) {
        imageObserver.observe(img);
      });
    } else {
      // Fallback: load all images immediately
      images.forEach(function(img) {
        img.src = img.dataset.src;
      });
    }
  }

  /**
   * Form Validation Enhancement
   */
  function initFormValidation() {
    $('form').on('submit', function() {
      const form = $(this);
      const requiredFields = form.find('[required]');
      let isValid = true;

      requiredFields.each(function() {
        const field = $(this);
        if (!field.val()) {
          field.addClass('error');
          isValid = false;
        } else {
          field.removeClass('error');
        }
      });

      return isValid;
    });

    // Remove error class on input
    $('input, textarea, select').on('input change', function() {
      $(this).removeClass('error');
    });
  }

  /**
   * Back to Top Button
   */
  function initBackToTop() {
    // Create button if it doesn't exist
    if (!$('.back-to-top').length) {
      $('body').append('<button class="back-to-top" aria-label="Voltar ao topo">&uarr;</button>');
    }

    const backToTop = $('.back-to-top');

    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 300) {
        backToTop.addClass('visible');
      } else {
        backToTop.removeClass('visible');
      }
    });

    backToTop.on('click', function() {
      $('html, body').animate({ scrollTop: 0 }, 600);
    });
  }

  /**
   * Product Grid Filter (if needed)
   */
  function initProductFilter() {
    $('.filter-button').on('click', function() {
      const filter = $(this).data('filter');

      $('.filter-button').removeClass('active');
      $(this).addClass('active');

      if (filter === 'all') {
        $('.produto-card').fadeIn();
      } else {
        $('.produto-card').hide();
        $('.produto-card[data-category="' + filter + '"]').fadeIn();
      }
    });
  }

  /**
   * Modal Window
   */
  function initModal() {
    // Open modal
    $('[data-modal]').on('click', function(e) {
      e.preventDefault();
      const modalId = $(this).data('modal');
      $('#' + modalId).fadeIn();
      $('body').addClass('modal-open');
    });

    // Close modal
    $('.modal-close, .modal-overlay').on('click', function() {
      $(this).closest('.modal').fadeOut();
      $('body').removeClass('modal-open');
    });

    // Close on ESC key
    $(document).on('keyup', function(e) {
      if (e.key === 'Escape') {
        $('.modal').fadeOut();
        $('body').removeClass('modal-open');
      }
    });
  }

  /**
   * Contact Form 7 Integration
   */
  function initCF7Integration() {
    // Auto-populate product field on seguros pages
    if ($('body').hasClass('single-seguros')) {
      const productName = $('.seguro-title').text();
      $('input[name="produto"]').val(productName);
    }

    // Track form submission
    document.addEventListener('wpcf7mailsent', function(event) {
      // Google Analytics tracking (if GA is loaded)
      if (typeof gtag !== 'undefined') {
        gtag('event', 'form_submission', {
          'event_category': 'Contact Form',
          'event_label': 'Form ID: ' + event.detail.contactFormId
        });
      }
    }, false);
  }

  /**
   * Partners Carousel
   * One item per click, infinite loop.
   * Shows 4 items on desktop, 3 on tablet, 2 on small tablet, 1 on mobile.
   * NOTE: gap values must match _partners-section.scss
   *       (desktop: 2rem = 32px | mobile: 1.25rem = 20px)
   */
  function initPartnersCarousel() {
    var $carousel = $('.partners-carousel');
    if (!$carousel.length) return;

    var $wrapper  = $carousel.find('.carousel-track-wrapper');
    var $track    = $carousel.find('.carousel-track');
    var $items    = $carousel.find('.partner-item');
    var $dotsWrap = $carousel.find('.carousel-dots');
    var $prevBtn  = $carousel.find('.carousel-prev');
    var $nextBtn  = $carousel.find('.carousel-next');

    var total        = $items.length;
    var currentIndex = 0; // index of the first visible item
    var autoplayInterval = null;
    var AUTOPLAY_DELAY   = 4000;

    function getGap() {
      return $(window).width() <= 768 ? 20 : 32;
    }

    function getVisibleCount() {
      var w = $(window).width();
      if (w >= 992) return 4;
      if (w >= 768) return 3;
      if (w >= 576) return 2;
      return 1;
    }

    // Number of unique stop positions (each stop shifts by 1 item)
    function getTotalStops() {
      return Math.max(1, total - getVisibleCount() + 1);
    }

    function getItemWidth() {
      var visibleCount = getVisibleCount();
      var gap          = getGap();
      return ($wrapper.width() - (visibleCount - 1) * gap) / visibleCount;
    }

    function setItemWidths() {
      $items.css('width', getItemWidth() + 'px');
    }

    function goTo(index) {
      var stops = getTotalStops();

      // Infinite loop
      currentIndex = ((index % stops) + stops) % stops;

      var gap         = getGap();
      var itemWidth   = getItemWidth();
      var translateX  = -(currentIndex * (itemWidth + gap));

      $track.css('transform', 'translateX(' + translateX + 'px)');

      // Dots
      $dotsWrap.find('.carousel-dot').removeClass('active').eq(currentIndex).addClass('active');
    }

    function buildDots() {
      $dotsWrap.empty();
      var stops = getTotalStops();

      if (stops <= 1) {
        $prevBtn.hide();
        $nextBtn.hide();
        $dotsWrap.hide();
        return;
      }

      $prevBtn.show();
      $nextBtn.show();
      $dotsWrap.show();

      for (var i = 0; i < stops; i++) {
        (function(idx) {
          var $dot = $('<button class="carousel-dot" role="tab"></button>')
            .attr('aria-label', 'Item ' + (idx + 1))
            .on('click', function() {
              stopAutoplay();
              goTo(idx);
              startAutoplay();
            });
          $dotsWrap.append($dot);
        })(i);
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (getTotalStops() <= 1) return;
      autoplayInterval = setInterval(function() {
        goTo(currentIndex + 1);
      }, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Touch / swipe — one item per swipe
    var touchStartX = 0;
    $carousel.on('touchstart', function(e) {
      touchStartX = e.originalEvent.touches[0].clientX;
      stopAutoplay();
    });
    $carousel.on('touchend', function(e) {
      var diff = touchStartX - e.originalEvent.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
      startAutoplay();
    });

    // Arrow buttons — one item, loop
    $prevBtn.on('click', function() {
      stopAutoplay();
      goTo(currentIndex - 1);
      startAutoplay();
    });
    $nextBtn.on('click', function() {
      stopAutoplay();
      goTo(currentIndex + 1);
      startAutoplay();
    });

    // Pause autoplay on hover
    $carousel.on('mouseenter', stopAutoplay).on('mouseleave', startAutoplay);

    // Rebuild on resize (debounced)
    var resizeTimer;
    $(window).on('resize.partnersCarousel', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        currentIndex = 0;
        buildDots();
        setItemWidths();
        goTo(0);
      }, 200);
    });

    // Init
    buildDots();
    setItemWidths();
    goTo(0);
    startAutoplay();
  }

  /**
   * Values Carousel (Sobre Nós — valores section)
   * Same behaviour as Partners Carousel: one item per click, infinite loop.
   * NOTE: gap values must match _sobre-nos.scss
   *       (desktop: 2rem = 32px | mobile: 1.25rem = 20px)
   */
  function initValuesCarousel() {
    var $carousel = $('.values-carousel');
    if (!$carousel.length) return;

    var $wrapper  = $carousel.find('.carousel-track-wrapper');
    var $track    = $carousel.find('.carousel-track');
    var $items    = $carousel.find('.value-card');
    var $dotsWrap = $carousel.find('.carousel-dots');
    var $prevBtn  = $carousel.find('.carousel-prev');
    var $nextBtn  = $carousel.find('.carousel-next');

    var total        = $items.length;
    var currentIndex = 0;
    var autoplayInterval = null;
    var AUTOPLAY_DELAY   = 4000;

    function getGap() {
      return $(window).width() <= 768 ? 20 : 32;
    }

    function getVisibleCount() {
      var w = $(window).width();
      if (w >= 992) return 4;
      if (w >= 768) return 3;
      if (w >= 576) return 2;
      return 1;
    }

    function getTotalStops() {
      return Math.max(1, total - getVisibleCount() + 1);
    }

    function getItemWidth() {
      var visibleCount = getVisibleCount();
      var gap          = getGap();
      return ($wrapper.width() - (visibleCount - 1) * gap) / visibleCount;
    }

    function setItemWidths() {
      $items.css('width', getItemWidth() + 'px');
    }

    function goTo(index) {
      var stops = getTotalStops();
      currentIndex = ((index % stops) + stops) % stops;

      var gap        = getGap();
      var itemWidth  = getItemWidth();
      var translateX = -(currentIndex * (itemWidth + gap));

      $track.css('transform', 'translateX(' + translateX + 'px)');
      $dotsWrap.find('.carousel-dot').removeClass('active').eq(currentIndex).addClass('active');
    }

    function buildDots() {
      $dotsWrap.empty();
      var stops = getTotalStops();

      if (stops <= 1) {
        $prevBtn.hide();
        $nextBtn.hide();
        $dotsWrap.hide();
        return;
      }

      $prevBtn.show();
      $nextBtn.show();
      $dotsWrap.show();

      for (var i = 0; i < stops; i++) {
        (function(idx) {
          var $dot = $('<button class="carousel-dot" role="tab"></button>')
            .attr('aria-label', 'Item ' + (idx + 1))
            .on('click', function() {
              stopAutoplay();
              goTo(idx);
              startAutoplay();
            });
          $dotsWrap.append($dot);
        })(i);
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (getTotalStops() <= 1) return;
      autoplayInterval = setInterval(function() {
        goTo(currentIndex + 1);
      }, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    var touchStartX = 0;
    $carousel.on('touchstart', function(e) {
      touchStartX = e.originalEvent.touches[0].clientX;
      stopAutoplay();
    });
    $carousel.on('touchend', function(e) {
      var diff = touchStartX - e.originalEvent.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
      startAutoplay();
    });

    $prevBtn.on('click', function() {
      stopAutoplay();
      goTo(currentIndex - 1);
      startAutoplay();
    });
    $nextBtn.on('click', function() {
      stopAutoplay();
      goTo(currentIndex + 1);
      startAutoplay();
    });

    $carousel.on('mouseenter', stopAutoplay).on('mouseleave', startAutoplay);

    var resizeTimer;
    $(window).on('resize.valuesCarousel', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        currentIndex = 0;
        buildDots();
        setItemWidths();
        goTo(0);
      }, 200);
    });

    buildDots();
    setItemWidths();
    goTo(0);
    startAutoplay();
  }

  /**
   * Banner Carousel
   */
  function initBannerCarousel() {
    var $carousel = $('.banner-carousel');
    if (!$carousel.length) return;

    var $slides = $carousel.find('.banner-slide');
    var $dots = $carousel.find('.carousel-dot');
    var current = 0;
    var total = $slides.length;
    var interval = null;
    var delay = 5000;

    function goTo(index) {
      $slides.removeClass('active').eq(index).addClass('active');
      $dots.removeClass('active').eq(index).addClass('active');
      current = index;
    }

    function next() {
      goTo((current + 1) % total);
    }

    function startAutoplay() {
      interval = setInterval(next, delay);
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    $dots.on('click', function() {
      stopAutoplay();
      goTo($(this).data('slide'));
      startAutoplay();
    });

    // Touch swipe support
    var touchStartX = 0;
    $carousel.on('touchstart', function(e) {
      touchStartX = e.originalEvent.touches[0].clientX;
      stopAutoplay();
    });
    $carousel.on('touchend', function(e) {
      var diff = touchStartX - e.originalEvent.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo((current + 1) % total) : goTo((current - 1 + total) % total);
      }
      startAutoplay();
    });

    startAutoplay();
  }

  /**
   * Initialize all functions when document is ready
   */
  $(document).ready(function() {
    initMobileMenu();
    initSmoothScroll();
    initFormTabs();
    initAccordion();
    initStickyHeader();
    initLazyLoad();
    initFormValidation();
    initBackToTop();
    initProductFilter();
    initModal();
    initCF7Integration();
    initBannerCarousel();
    initPartnersCarousel();
    initValuesCarousel();

    // Log initialization
    console.log('JAPSeguros theme initialized');
  });

  /**
   * Window Load Event
   */
  $(window).on('load', function() {
    // Add any functions that need to run after full page load
  });

  /**
   * Window Resize Event (Debounced)
   */
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Add any functions that need to run on window resize
    }, 250);
  });

})(jQuery);
